export const formatNumber = (n: number, lang: string): string => {
  switch (lang) {
    case 'ja-JP':
    case 'zh-CN':
    case 'zh-TW':
      return String(n);
    case 'en-US':
    case 'en-GB':
    case 'ko-KR':
      return new Intl.NumberFormat('en-US').format(n);
    case 'fr-FR':
    case 'fr-CA': {
      const cs = Array.from(String(n));
      return chunkString(cs).join(' ');
    }
    case 'es-ES':
    case 'es-US':
    case 'de-DE':
    case 'ru-RU': {
      const cs = Array.from(String(n));
      if (cs.length <= 4) {
        return String(n);
      }
      return chunkString(cs).join(' ');
    }
    case 'it-IT':
    case 'nl-NL': {
      const cs = Array.from(String(n));
      if (cs.length <= 4) {
        return String(n);
      }
      return chunkString(cs).join('.');
    }
    default:
      return String(n);
  }
};

function chunkString(chars: string[]) {
  const copied = [...chars];
  const headSize = copied.length % 3;
  const headString = copied.slice(0, headSize).join('');

  const toChunked = copied.slice(headSize, copied.length);
  const chunkedStrings = Array.from({ length: Math.ceil(toChunked.length / 3) }, (_, i) =>
    toChunked.slice(i * 3, i * 3 + 3).join('')
  );

  if (headString === '') {
    return chunkedStrings;
  } else {
    return [headString, ...chunkedStrings];
  }
}
